<div class="flex flex-col-reverse md:flex-row items-center rounded-lg">
    <div class="md:w-3/5 md:mt-0 w-10/12 mt-4">
        <div class="md:pl-12 text-center md:text-right">
            <h4 class="md:text-2xl text-base font-bold mb-6">
                چه نوع سفری دوست داری؟
            </h4>
            <p class="text-black-300 mb-6 text-sm">
                در مسابقه سفر سریع ما شرکت کنید. ما سبک سفر شما را آشکار خواهیم کرد و از ترجیحات شخصی شما استفاده می کنیم تا توصیه هایی را به شما ارایه دهیم که دوست دارید.
            </p>
            <div class="flex md:justify-end justify-center">
                <button class="bg-blue-500 text-white py-2 px-4 rounded-lg">
                    تست شخصیت سفر
                </button>
            </div>
        </div>
    </div>
    
    <div class="md:w-2/5 w-10/12">
        <img [src]="imageSrc" class="w-full rounded-3xl" />
    </div>
</div>